import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IItemResponse } from 'lingo2-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameService } from './game.service';
import { voiceCodes } from './vocabulary.variables';

@Injectable({
  providedIn: 'root',
})
export class OpenAiService {
  public constructor(
    private http: HttpClient,
    private gameService: GameService,
  ) {}

  public translateWord(text: string, sourceLang: string, targetLang: string): Observable<string> {
    const url = `https://${this.gameService.host}/web/content/proxy/openai`;
    const prompt = `Translate this word from ${sourceLang} to ${targetLang}: ${text}`;

    const data = {
      prompt,
      max_tokens: 1024,
      n: 1,
      stop: false,
      temperature: 0.7,
    };
    return this.http.post<{ text: string }>(url, data).pipe(map((response) => response.text));
  }

  public generateSpeech(text: string, lang_id: number) {
    const url = `https://${this.gameService.host}/web/content/proxy/playht`;
    const voice = voiceCodes.find((el: any) => el.code == lang_id)
      ? voiceCodes.find((el: any) => el.code == lang_id)?.codeMale
      : 'en-GB-RyanNeural';
    const payload = { text, voice };
    return this.http
      .post<IItemResponse<string>>(url, payload, { observe: 'body' })
      .pipe(map((response: IItemResponse<string>) => response.item));
  }
}
